class TaskDeliverablePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_deliverable.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_deliverable._m';

    // Can access archived items
    static ACCESS_ARCHIVE = 'task_deliverable.access.archive';

    // Can access unapproved items
    static ACCESS_UNAPPROVED = 'task_deliverable.access.unapproved';

    // Can create new task deliverables
    static CREATE = 'task_deliverable.create';

    // Can create new task deliverables if assigned to task
    static CREATE_MOD_TASK_ASSIGNED = 'task_deliverable.create.mod.task_assigned';

    // Can approve task deliverables
    static APPROVE = 'task_deliverable.approve';

    // Can approve only if assigned to a task
    static APPROVE_MOD_TASK_ASSIGNED = 'task_deliverable.approve.mod.task_assigned';

    // Can archive task deliverables
    static ARCHIVE = 'task_deliverable.archive';

    // Can archive deliverables only if assigned to a task
    static ARCHIVE_MOD_TASK_ASSIGNED = 'task_deliverable.archive.mod.task_assigned';

    // Can restore task deliverables
    static RESTORE = 'task_deliverable.restore';

    // Can restore only if assigned to a task
    static RESTORE_MOD_TASK_ASSIGNED = 'task_deliverable.restore.mod.task_assigned';

}

export default TaskDeliverablePermission;
